import { render } from "./QueueDeletePage.vue?vue&type=template&id=d6e0353a"
import script from "./QueueDeletePage.vue?vue&type=script&lang=js"
export * from "./QueueDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__